import { NavLink } from 'react-router-dom';
import { BarChart3, CalendarDays, FolderCog, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { usePermissions } from '@/hooks/use-permissions';

type PlanningNavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
  capability?: string;
};

const planningNavItems: PlanningNavItem[] = [
  { label: 'Planning', to: '/planning', icon: CalendarDays },
  {
    label: 'Production',
    to: '/planning/production',
    icon: BarChart3,
    capability: 'planning.production.view',
  },
  {
    label: 'Catalog',
    to: '/planning/catalog',
    icon: FolderCog,
    capability: 'planning.catalog.view',
  },
];

export function PlanningSidebar() {
  const { hasCapability, isLoading } = usePermissions();

  const visibleItems = planningNavItems.filter((item) => {
    if (!item.capability) return true;
    if (isLoading) return false;
    return hasCapability(item.capability);
  });

  return (
    <aside className="flex h-full w-64 shrink-0 flex-col border-r border-border bg-card">
      <div className="border-b border-border px-4 py-3">
        <h2 className="text-sm font-semibold text-foreground">Planning</h2>
      </div>
      <nav className="space-y-1 p-2">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                )
              }
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
